export enum TicketFileSortField {
  ID = 'ID',
}
